import React, {useState, useEffect} from 'react';
import SarasTrans from '../../../library/notifications/SarasTrans'
import useSarasStore from '../../../library/hooks/localDB/useSarasStore'
import coreSettings from '../../../helper/coreSetting';
import {IconHelp} from '../../../library/decor/SarasIcons';

const UserManual=({deviceInfo})=>{
    const [manualLink, setManualLink] = useState('');
    const localDb = useSarasStore();

    const checkCulture = () => {
        if(!manualLink)
        {
            //get selected culture
            localDb.requestData("user_manual_link", onManualLinkRetrieved);
        }
    };

    useEffect(checkCulture, [manualLink]);

    //this is executed when my culture is retrieved from local db
    const onManualLinkRetrieved = (key, value) =>  {
        let newValue = value;

        //default to EN culture
        if(!newValue) newValue = coreSettings.defaultUserManualLink;

        if((manualLink || '').toLowerCase() !== (newValue || '').toLowerCase()){
            setManualLink(newValue);
        }
    }

    const onClick = (e) => {
        e.preventDefault();

        window.open(manualLink || coreSettings.defaultUserManualLink, "saras-help");
    }

    return(
        <>
            <span className='uiAppIconWithLink' onClick={onClick}>
                <IconHelp className='uiAppIcon'/>
                {!deviceInfo.activateMobileView && <span><SarasTrans value="Help?" /></span>}
            </span>
        </>
    )
}

export default UserManual